// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"CompanyBalanceInfoPanel_UsersInfoPanel__994R1","search":"CompanyBalanceInfoPanel_search__ilL2X","groupButton":"CompanyBalanceInfoPanel_groupButton__TdgPu"};